import { publicRequest } from "../../requestMethod";


export const FETCH_TEMPLATE_REQUEST = 'FETCH_TEMPLATE_REQUEST';
export const FETCH_TEMPLATE_SUCCESS = 'FETCH_TEMPLATE_SUCCESS';
export const FETCH_TEMPLATE_FAILURE = 'FETCH_TEMPLATE_FAILURE';
export const TEMPLATE_EDIT_SUCCESS = 'TEMPLATE_EDIT_SUCCESS';
export const TEMPLATE_EDIT_FAILURE = 'TEMPLATE_EDIT_FAILURE';



export function fetchProject() {
  return async(dispatch) => {
   const {data}= await publicRequest.get('/api/project')
   if (data) {
    
        dispatch({type: FETCH_TEMPLATE_SUCCESS, payload: data});
    }else{
        dispatch({type: FETCH_TEMPLATE_FAILURE})
    }
   }
  }
export function fetchProjectById(id) {
  return async(dispatch) => {
   const {data}= await publicRequest.get(`/api/project/${id}`)
  
   if (data) {
    
        return data
    }else{
        return false
    }
   }
  }


export function editProject(changedField, addToast) {
  return async(dispatch) => {
   const {data}= await publicRequest.put(`/api/project/update/${changedField.id}`, changedField)
  
   if (data) {
     if (addToast) {
      addToast("Project updated successfully", { appearance: "success", autoDismiss: true });
        
     }
        dispatch(fetchProject());
    }else{
        dispatch({type: TEMPLATE_EDIT_FAILURE})
    }
   }
  }


export function addProject(projectdata, addToast) {

  return async(dispatch) => {
    const headers= {
      'accept': 'application/json',
      'Accept-Language': 'en-US,en;q=0.8',
      'Content-Type': `multipart/form-data`
      // 'Content-Type': 'application/json'

      }
   const {data}= await publicRequest.post(`/api/project/add`, projectdata, headers)
 
  
   if (data) {
   
  
      
        addToast("New project added successfully", { appearance: "success", autoDismiss: true });
        dispatch(fetchProject());
        return true;
      
    }else{
        dispatch({type: TEMPLATE_EDIT_FAILURE})
    }
   }
  }

export function deleteProject(id, addToast) {
  return async(dispatch) => {
   const {data}= await publicRequest.delete(`/api/project/delete/${id}`)
  
   if (data) {
    if (addToast) {
      addToast("Project deleted successfully", { appearance: "error", autoDismiss: true });
    }
       await dispatch(fetchProject());
      
        
    }else{
        dispatch({type: TEMPLATE_EDIT_FAILURE})
    }
   }
  }

